<template>
    <div class="steel-results">
        <div class="row" v-if="data">
            <div
                v-for="(item, index) in data"
                :key="index"
                class="col-default-4 col-tablet-6 col-v-tablet-12"
            >
                <z-card
                    :link="item.link"
                    :theme="item.image.length ? 'background' : ''"
                    :image="item.image"
                    padding="218px"
                    autoHeight
                >
                    <template v-slot:title>
                        {{ item.name }}
                    </template>
                </z-card>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'results',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        nav: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            text: {
                period: localize({
                    ru: 'Период',
                    en: 'Period'
                }),
                fileName: localize({
                    ru: 'Наименование документа',
                    en: 'File name'
                }),
                size: localize({
                    ru: 'Размер',
                    en: 'Size'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.steel-results {
    margin-bottom: 24px;

    &__text {
        white-space: nowrap;
    }

    &__link {
        > span {
            display: flex;
            font-weight: 500;
            align-items: flex-start;
        }

        .z-icon {
            flex-shrink: 0;
            margin-right: $token-spacers-s;
            margin-top: 3px;
        }
    }
}
</style>
